import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Stack,
  Button,
  IconButton,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Paper,
  CircularProgress,
  Popover,
  Typography,
  Divider,
  MenuItem,
  List,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  FormControl,
  FormControlLabel,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputLabel,
  Select,
  TextField,
} from '@mui/material'


import client from '../common/client'
import AceEditor from 'react-ace'
import 'brace/ext/searchbox'
import 'ace-builds/src-noconflict/mode-java'
import 'ace-builds/src-noconflict/theme-github'
import toast, { Toaster } from 'react-hot-toast'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import AddIcon from '@mui/icons-material/Add'
import SettingsIcon from '@mui/icons-material/Settings';
import { getSelectedProject } from '../common/common.js'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const IDEScreenSetting = props => {
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [header_block_id, setHeader_block_id] = useState('')
  const [footer_block_id, setFooter_block_id] = useState('')
  const [fit_to_screen, setFit_to_screen] = useState(false)
  const [double_back_to_finish, setdouble_back_to_finish] = useState(false)
  const [orientation_change, setorientation_change] = useState(false)
  const [inside_footer, setinside_footer] = useState(false)
  const [footer_shadow, setfooter_shadow] = useState(false)

  const [blockList, setBlockList] = useState([])
  const [modified, setModified] = useState(false);
  const [screenName, setScreenName] = useState('');

  useEffect(() => {
    if (props.screen_id) {
      update()
    }
  }, [props.screen_id])

  const handleChangeHeader = (event) => {
    setHeader_block_id(event.target.value)
    setModified(true)
  }

  const handleChangeFooter = (event) => {
    setFooter_block_id(event.target.value)
    setModified(true)
  }

  const update = () => {
    client.request_get(`/screen?project_id=` + getSelectedProject()).then(screen_list => {
      client.request_get(`/block?project_id=` + getSelectedProject()).then(all_block_list => {
        let screen = screen_list.find(f=>f.id == props.screen_id)
        if(screen && screen.block_list && screen.block_list.length > 0) {
          let block = all_block_list.find(f=>f.id == screen.block_list[0].block_id)
          setFit_to_screen(block.fit_to_screen)
        }
        setScreenName(screen.name)

        setHeader_block_id(null)
        setFooter_block_id(null)
        setinside_footer(false)

        if (screen.header_block_id)
          setHeader_block_id(screen.header_block_id)
        
        if (screen.footer_block_id) {
          setFooter_block_id(screen.footer_block_id)
          setinside_footer(false)
        }

        if(screen.inside_footer_block_id) {
          setFooter_block_id(screen.inside_footer_block_id)
          setinside_footer(true)
        }

        setdouble_back_to_finish(screen.double_back_to_finish)
        setorientation_change(screen.orientation_change)
        setfooter_shadow(screen.footer_shadow)

        let block_list = []
        all_block_list.map(m => {
          let found = screen_list.find(f => f.block_list && f.block_list.length > 0 && f.block_list[0].block_id == m.id)
          if (!found)
            block_list.push(m)
        })
        setBlockList(block_list)
      })
    })
  }

  const save = () => {
    toast.promise(
      getSavePromise(),
      {
        loading: 'Saving...',
        success: <b>Saved!</b>,
        error: <b>Could not save.</b>,
      }
    );
  }

  const getSavePromise = () => {
    return new Promise((resolve, reject) => {
      let param = {}
      param.name = screenName
      param.fit_to_screen = fit_to_screen
      param.header_block_id = header_block_id
      param.orientation_change = orientation_change
      param.double_back_to_finish = double_back_to_finish
      param.footer_shadow = footer_shadow

      if(inside_footer) {
        param.footer_block_id = null
        param.inside_footer_block_id = footer_block_id
      } else {
        param.footer_block_id = footer_block_id
        param.inside_footer_block_id = null
      }

      client.request_post('/api/screen/setting/' + props.screen_id, param).then(res => {
        setModified(false)
        resolve();
      })
    })
  }

  return (
    <Box sx={{ width: '100%', height: '100%', textAlign: 'left', }}>
      <Toaster position='bottom-center' reverseOrder={false} />
      <Stack spacing={1} p={3} sx={{height: 'calc(100% - 50px)',}}>

        <Box>
          <Typography variant="h7">
            Base Setting
          </Typography>
        </Box>

        <Divider />
        <Box>
          <TextField label="Screen Name" variant="outlined" value={screenName} onChange={e=>{setModified(true);setScreenName(e.target.value)}} />
        </Box>
        <Box display={'flex'} alignItems={'center'}>
          <FormControlLabel control={<Checkbox checked={fit_to_screen} onChange={(e)=>{
              setFit_to_screen(e.target.checked);setModified(true)}}/>} label="Fit Screen" />
          <HelpOutlineIcon />
        </Box>
        <Box display={'flex'} alignItems={'center'}>
          <FormControlLabel control={<Checkbox checked={double_back_to_finish} onChange={(e)=>{
              setdouble_back_to_finish(e.target.checked);setModified(true)}}/>} label="Double Back Button(Android Only)" />
          <HelpOutlineIcon />
        </Box>
        <Box display={'flex'} alignItems={'center'}>
          <FormControlLabel control={<Checkbox checked={orientation_change} onChange={(e)=>{
              setorientation_change(e.target.checked);setModified(true)}}/>} label="Orientation Change Enable" />
          <HelpOutlineIcon />
        </Box>

        <Stack pt={3} direction={'row'} spacing={1}>
          <Typography variant="h7">
            Header
          </Typography>
          <HelpOutlineIcon />
        </Stack>

        <Divider />
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="demo-select-small-label">Header Block</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={header_block_id}
            label="Header Block"
            onChange={handleChangeHeader}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {blockList.map(m => (
              <MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Stack pt={3} direction={'row'} spacing={1}>
          <Typography variant="h7">
            Footer
          </Typography>
          <HelpOutlineIcon />
        </Stack>
        <Divider />
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="demo-select-small-label">Footer Block</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={footer_block_id}
            label="Footer Block"
            onChange={handleChangeFooter}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {blockList.map(m => (
              <MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box display={'flex'} alignItems={'center'}>
          <FormControlLabel control={<Checkbox checked={inside_footer} onChange={(e)=>{
              setinside_footer(e.target.checked);setModified(true)}}/>} label="Inside Footer" />
          <HelpOutlineIcon />
        </Box>

        <Box display={'flex'} alignItems={'center'}>
          <FormControlLabel control={<Checkbox checked={footer_shadow} onChange={(e)=>{
              setfooter_shadow(e.target.checked);setModified(true)}}/>} label="Shadow" />
          <HelpOutlineIcon />
        </Box>
      </Stack>

      <Box sx={{
        width: '100%',
        height: '50px',
      }}>
        <Divider />
        <Box sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          paddingLeft: '10px'
        }}>
          <Button variant="contained" disabled={!modified} onClick={save} >Save</Button>
        </Box>
      </Box>
    </Box>
  )
}

export default IDEScreenSetting
